import React from "react";
import { ElementsViewer } from "@wuilt/section-preview";
import useElements from "../hooks/useElements";
import { ImageSettingsExtended, migrateElement } from "./image-migration";

export interface ImageProps {
  value: ImageSettingsExtended;
  aspectRatio: string;
  className: string;
  withContainer: string;
  stopAction?: boolean;
}

const Image: React.FC<ImageProps> = ({
  value,
  aspectRatio,
  className,
  withContainer,
  stopAction,
}) => {
  const wuiltContext = useElements();
  const element = migrateElement(value.id || "fake-id", value as any);

  const ImageComponent = (
    <ElementsViewer.Image
      element={{ ...element, id: value.id || element.id }}
      wuiltContext={wuiltContext}
      asBackground={!!aspectRatio}
      customClassName={className}
      aspectRatio={aspectRatio?.replace(":", "/")}
      stopAction={stopAction}
    />
  );

  if (withContainer) {
    return <div className={withContainer}>{ImageComponent}</div>;
  }

  return ImageComponent;
};

export default Image;
